var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 154,
    viewBox: "0 0 150 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.841 85.0479H96.1365L85.5683 100.317H64.4319L53.8637 85.0479H22.1592",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3893 49.9788L22.1592 85.0479V115.587C22.1592 118.287 23.2726 120.876 25.2545 122.785C27.2364 124.694 29.9245 125.767 32.7274 125.767H117.273C120.076 125.767 122.764 124.694 124.746 122.785C126.728 120.876 127.841 118.287 127.841 115.587V85.0479L109.611 49.9788C108.736 48.2828 107.387 46.8556 105.716 45.8575C104.045 44.8594 102.118 44.3301 100.152 44.3291H49.8478C47.8817 44.3301 45.9548 44.8594 44.2839 45.8575C42.613 46.8556 41.2642 48.2828 40.3893 49.9788V49.9788Z",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0005 21.3889L75.0005 29.9915",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7556 26.7665L87.4405 32.8494",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2454 26.7665L62.5604 32.8494",
    stroke: "#E4D5C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame70);
export default __webpack_public_path__ + "static/media/Frame 70.d11f9e0b96c8a909ce8d6f294b1eff34.svg";
export { ForwardRef as ReactComponent };